export function getPercentage(currentValue = 0, totalValue = 100) {
  const percentual = (currentValue * 100) / totalValue
  return percentual < 1 ? Math.ceil(percentual) : Math.floor(percentual)
}
